import * as R from 'ramda'
import moment from 'moment'
import interval from 'days-interval'
import { parsePeriod } from 'utils/stuff'

export default (properties, leases, terms, startMarketDateByPropertyID, period) => {
	let parsedPeriod = period == 'projected' ? parsePeriod(moment().year()) : parsePeriod('YTM')

	let termsByParentID = R.pipe(R.values, R.filter(x => x.parentID), R.groupBy(R.prop('parentID')))(leases)
	let sortedTerms = R.map(terms => R.sortBy(x => moment(x.dateTill))(terms))(termsByParentID)

	let res = R.map(property => {
		let startPeriod = moment(parsedPeriod.from) > moment(startMarketDateByPropertyID[property._id]) ? parsedPeriod.from : startMarketDateByPropertyID[property._id]
		let propertyLeases = R.pipe(
			R.values
		  , R.filter(x => !x.parentID)
		  , R.map(x => {x.dateTill = sortedTerms[x._id] ? sortedTerms[x._id][sortedTerms[x._id].length-1].dateTill : x.dateTill; return x;})
		  , R.filter(lease =>(
				lease.propertyID == property._id
				&&
				(moment(lease.dateTill) >= moment(startPeriod) && moment(lease.dateTill) < moment(parsedPeriod.to)
				||
				moment(lease.dateFrom) >= moment(startPeriod) && moment(lease.dateTill) < moment(parsedPeriod.to)
				||
				moment(lease.dateFrom) >= moment(startPeriod) && moment(lease.dateFrom) < moment(parsedPeriod.to)
				||
				moment(lease.dateFrom) <= moment(startPeriod) && moment(lease.dateTill) >= moment(parsedPeriod.to))
			))
		)(leases)

		if(!(propertyLeases && propertyLeases.length)) return 0
		let intervals = R.values(R.map(x => ({firstDay: x.dateFrom, lastDay: moment(x.breakDateTill || x.dateTill) > moment(parsedPeriod.to) ? parsedPeriod.to : x.breakDateTill || x.dateTill}), propertyLeases))
		if(
			period == 'projected'
			&&
			moment(intervals[intervals.length-1].lastDay) < moment(parsedPeriod.to)
			&&
			moment(intervals[intervals.length-1].lastDay).add(30, 'days') < moment(parsedPeriod.to)
		){
			intervals.push({firstDay: moment(intervals[intervals.length-1].lastDay).add(30, 'days').format('YYYY-MM-DD'), lastDay: parsedPeriod.to})
		}
		let daysOfRent = 0;
		R.map(x => {
			let intr = interval.intersection({firstDay: startPeriod, lastDay: parsedPeriod.to}, x)
			if (intr) daysOfRent += moment(intr.lastDay).diff(moment(intr.firstDay), 'days')
		})(intervals)
		daysOfRent = daysOfRent / moment(parsedPeriod.to).diff(moment(startPeriod), 'days') * 100
		return daysOfRent
	})(properties)

	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0), (acc) => acc / Object.keys(properties).length)(res)

	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/occupancyRate.js